export default function BookSteps({ current }) {
  const steps = ['Guest details', 'Payment', 'Confirmation'];
  return (
    <ol className="book-steps" aria-label="Booking steps">
      {steps.map((label, i) => (
        <li
          key={label}
          className={i === current ? 'is-current' : i < current ? 'is-done' : ''}
          aria-current={i === current ? 'step' : undefined}
        >
          <span>{i + 1}</span>
          {label}
        </li>
      ))}
    </ol>
  );
}
